import {Component, Input} from "@angular/core";
import {AppSearchFacet, AppSearchFacets} from "../../../models/appSearch.model";
import {AuthService} from "../../../../shared/services/auth.service";

@Component(
        {
            selector: 'catalogue-app-search-breadcrumbs',
            templateUrl: './app-search-breadcrumbs.component.html'
        }
)
export class AppSearchBreadcrumbsComponent {
    @Input() public facets: AppSearchFacets[];

    constructor(
            public authService: AuthService
    ) {
    }

    public getQueryParams(facet: AppSearchFacet) {
        let queryParams = {},
                matches = facet.cid.match(/(\d+)/);

        if (matches) {
            let level = parseFloat(matches.shift());
            for (let i = 1; i <= level; i++) {
                for (let facets of this.facets) {
                    for (let facet of facets) {
                        if (facet.cid === 'product_hierarchy_level_' + i) {
                            queryParams['filters[product_hierarchy_level_' + i + '][]'] = facet.options.filter(
                                    facetOption => facetOption.checked
                            ).map(
                                    facetOption => facetOption.value
                            );
                        }
                    }
                }
            }
        }

        return queryParams;
    }
}